import { Typography } from '@material-ui/core'
import React, { useContext } from 'react'
import { CoreContext } from '../context/CoreContext'
import TranslationLabel, { translationLink } from './TranslationLabel'

function HelpPage(props) {
  const core = useContext(CoreContext)
  const { appId } = props
  const label = 'helpPageLabel' + appId

  return (
    <a
      target='_blank'
      rel='noopener noreferrer'
      href={translationLink(core.dictionary, label)}>
      <Typography
        style={{ color: 'blue', textDecoration: 'underline' }}
        variant='subtitle1'
        component='h1'>
        <TranslationLabel
          type='link'
          name={label}
        />
      </Typography>
    </a>
  )
}

export default HelpPage
